// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDQlYMK4sxZIBfp5nADRugnAg5Gu9OB_84",
  authDomain: "portfolio-47bbe.firebaseapp.com",
  projectId: "portfolio-47bbe",
  storageBucket: "portfolio-47bbe.appspot.com",
  messagingSenderId: "1003472983911",
  appId: "1:1003472983911:web:59795a8ca860f1de7d81c2",
  measurementId: "G-5L6FNN8RCJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);